import { hasFeature, isVerified } from './plan';

/**
 * Plan facts for one provider. Takes providerData explicitly (the dashboard
 * passes it down from DashboardRouter) so the hook stays a pure projection.
 */
export const usePlan = (providerData) => ({
  isPro: Boolean(providerData?.isProPlan),
  isVerified: isVerified(providerData),
  has: (feature) => hasFeature(providerData, feature),
});
